import React from "react";
import Component from "../../../components/AscComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as solidfaIcon from "@fortawesome/free-solid-svg-icons";
import * as regularfaIcon from "@fortawesome/free-regular-svg-icons";
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem, Button, Glyphicon, ButtonToolbar, Overlay, OverlayTrigger, Popover, FormControl, Radio} from "react-bootstrap";
import "./Header.css";
import UserChangeSelfPasswordModal from "../../User/UserChangeSelfPasswordModal"
import moment from "moment";

// Reactで画像表示する場合css上でのbackgroundimage使用不可(画像が呼べない)
// headerとAppのみ特例でStyle直書きしてます

export default class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            overlay_show: false,
            oldPassword:    '',
            newPassword:    '',
            newPasswordRe:  '',
            bookmark_flag: false,
            setting_flag: false,
            user_menu_show: false,
            // 個人設定（初期値は後で上書き）
            pref_audio_speed: 1,
            pref_auto_scroll: false,
            pref_add_call_history_id: false,
            saving_personal_settings: false,
            personal_dirty: false
        };

        this.notification_button = React.createRef();
        this.user_button = React.createRef();
        this.audioSpeedSelect = this.props.childProps.langText.SelectOption.AudioSpeed;
    }

    componentDidMount = () => {
        this.bookmarkPermission();
        this.settingPermission();
        // Appのグローバル設定を初期表示に反映
        const playbackSettings = this.props.childProps.playbackSettings;
        if (playbackSettings) {
            this.setState({
                pref_audio_speed: playbackSettings.audioSpeed,
                pref_auto_scroll: playbackSettings.autoScroll
            });
        }
        const downloadSettings = this.props.childProps.downloadSettings;
        if (downloadSettings) {
            this.setState({
                pref_add_call_history_id: downloadSettings.addCallHistoryId
            });
        }
    }

    componentDidUpdate = (prevProps) => {
        const downloadSettings = this.props.childProps.downloadSettings;
        const prevDownloadSettings = prevProps.childProps.downloadSettings;
        if (downloadSettings && downloadSettings !== prevDownloadSettings) {
            this.setState({
                pref_add_call_history_id: downloadSettings.addCallHistoryId
            });
        }
    }

    handleMouseOver = event => {
        this.setState({disabled: false});
    };

    handleMouseOut = event => {
        this.setState({disabled: true});
    };

    handleLogout = async event => {
        if (window.confirm("ログアウトしますか?")) {
            await this.ascAxios("post", "/Sign/logout");

            window.location.replace("/signIn");
        }       
    };

    handleChangePassword = () => {
        this.setState({
            show: true,
            modalType: "updateSelfPassword",
            oldPassword:    '',
            newPassword:    '',
            newPasswordRe:  ''
        });
    }
    // 個人設定の保存（サーバー）
    handleSavePersonalSettings = async () => {
        if (this.state.saving_personal_settings) return;
        this.setState({ saving_personal_settings: true });
        try {
            const [playbackOk, downloadOk] = await Promise.all([
                this.props.childProps.savePlaybackSettings({
                    audioSpeed: this.state.pref_audio_speed,
                    autoScroll: this.state.pref_auto_scroll
                }),
                this.props.childProps.saveDownloadSettings({
                    addCallHistoryId: this.state.pref_add_call_history_id
                })
            ]);
            if (!playbackOk) {
                // 失敗時はデフォルト表示へ戻す
                this.setState({ pref_audio_speed: 1, pref_auto_scroll: false });
            }
            if (!downloadOk) {
                this.setState({ pref_add_call_history_id: false });
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ saving_personal_settings: false, personal_dirty: false });
        }
    }

    downloadHistory = async (path, nt01_id) => {
        let {
            userInfo,
            historyPush
        } = this.props.childProps;
        let cm12_id = userInfo.company_id;
        let company_name = userInfo.company_name;
        let cm13_id = userInfo.department_id;
        let cm15_id = userInfo.cm15_id;
        let floor_flg = userInfo.floor_flg ? "Y" : "N";
    
        try {
            await this.ascAxios("post", "Common/readNotification", {id: nt01_id});
        } catch (err) {
            console.error(err)
        }

        this.setShowOverlay()

        historyPush({
            pathname: path,
            state: [
                {
                    id: "cm12_id",
                    value: {
                        floor_flg: floor_flg,
                        label: company_name,
                        value: cm12_id
                    }
                },
                {
                    id: "cm15_id",
                    value: {
                        label: userInfo.user_name_sei + userInfo.user_name_mei,
                        value: {
                            id: cm15_id,
                            cm12_id: cm12_id,
                            cm13_id: cm13_id
                        }
                    }
                }
            ]
        });
    }

    setShowOverlay = () => { this.setState({ overlay_show: !this.state.overlay_show }); }

    // ユーザーポップオーバーの表示制御
    toggleUserMenu = () => { 
        const playbackSettings = this.props.childProps.playbackSettings;
        const downloadSettings = this.props.childProps.downloadSettings;
        if (playbackSettings) {
            this.setState({
                pref_audio_speed: playbackSettings.audioSpeed,
                pref_auto_scroll: playbackSettings.autoScroll,
                pref_add_call_history_id: downloadSettings ? downloadSettings.addCallHistoryId : false,
                user_menu_show: !this.state.user_menu_show,
                personal_dirty: false
            });
        } else {
            this.setState({ user_menu_show: !this.state.user_menu_show });
        }
    }
    hideUserMenu = () => {
        const playbackSettings = this.props.childProps.playbackSettings;
        const downloadSettings = this.props.childProps.downloadSettings;
        if (playbackSettings) {
            this.setState({
                pref_audio_speed: playbackSettings.audioSpeed,
                pref_auto_scroll: playbackSettings.autoScroll,
                pref_add_call_history_id: downloadSettings ? downloadSettings.addCallHistoryId : false,
                user_menu_show: false,
                personal_dirty: false
            });
        } else {
            this.setState({ user_menu_show: false });
        }
    }

    // 個人設定の更新
    onChangeAudioSpeed = (e) => {
        const value = parseFloat(e.target.value || 1);
        const settings = (this.props.childProps && this.props.childProps.playbackSettings) ? this.props.childProps.playbackSettings : { audioSpeed: 1, autoScroll: false };
        const dirty = (value !== settings.audioSpeed) || (this.state.pref_auto_scroll !== settings.autoScroll);
        this.setState({ pref_audio_speed: value, personal_dirty: dirty });
    }
    onChangeAutoScroll = (enabled) => {
        const settings = (this.props.childProps && this.props.childProps.playbackSettings) ? this.props.childProps.playbackSettings : { audioSpeed: 1, autoScroll: false };
        const nextAuto = !!enabled;
        const dirty = (this.state.pref_audio_speed !== settings.audioSpeed) || (nextAuto !== settings.autoScroll);
        this.setState({ pref_auto_scroll: nextAuto, personal_dirty: dirty });
    }

    onChangeAddCallHistoryId = (value) => {
        this.setState({ pref_add_call_history_id: value, personal_dirty: true });
    }

    bookmarkPermission = async () => {
        const bookmarkPermission = this.props.childProps.userInfo.permission_json_data.find(
            permission => permission.controller_id === "Bookmark"
        );
        let flag = false;
        try {
            const result = await this.ascAxios("post", "Common/getCompanyControlCallEval");
            
            if (bookmarkPermission && bookmarkPermission.read && result.data && result.data.parameter_value === "Y") flag = true;

            this.setState({ bookmark_flag: flag });
        } catch (err) {
            console.error(err);
            alert(err);
        }
    }

    settingPermission = async () => {
        let flag = false;
        try {
            const result = await this.getCompanyControlParameters(this.props.childProps.userInfo.company_id);
            const callAnalysisFlag = result && result.length > 0 ? result.find(row => row.parameter_id === "CALL_ANALYSIS_OPTION") : null;
            if (callAnalysisFlag && callAnalysisFlag.parameter_value === "Y") flag = true;

            this.setState({ setting_flag: flag });
        } catch (err) {
            console.error(err);
            alert(err);
        }
    }

    render() {
        let navbarHeaderElem = <Navbar.Header>
            <Navbar.Brand>
                {/*<Link to="/" className="hover-black margin-left-05 margin-top-03">{this.props.childProps.langText.Header.MainLink}</Link>*/}
                <a className="hover-black margin-left-05 margin-bottom-10"><img src = {this.props.childProps.systemParameters["HEADERLOGO"]} onClick={e => this.props.childProps.historyPush("/")}></img></a>
            </Navbar.Brand>
            <Navbar.Toggle/>
        </Navbar.Header>;

        let navbarCollapseElem = null;
        let user_info = (
            <Popover id="popover-User-Info" title={this.props.childProps.langText.Body.UserInfo}>
                <strong>{this.props.childProps.langText.Body.EmailAddress}:</strong> &nbsp; {this.props.childProps.userInfo.user_id}<br/>
                <strong>{this.props.childProps.langText.Body.UserName}:</strong> &nbsp; {this.props.childProps.userInfo.user_name_sei + this.props.childProps.userInfo.user_name_mei}<br/>
                <strong>{this.props.childProps.langText.Body.Auth}:</strong> &nbsp; {this.props.childProps.userInfo.permission_name}
                {
                    this.state.setting_flag &&
                    <>
                        <hr/>
                        <div className="user-personal-settings">
                            <div className="font-weight-bold margin-bottom-05">{this.props.childProps.langText.Body.PersonalSetting}</div>
                            {/* 再生速度（1行） */}
                            <div className="setting-row">
                                <div className="setting-label">{this.props.childProps.langText.Body.PlaySpeed}</div>
                                <div className="setting-control setting-select-padding-left">
                                    <FormControl
                                        componentClass="select"
                                        className="width-auto display-inline-block"
                                        value={this.state.pref_audio_speed}
                                        onChange={this.onChangeAudioSpeed}
                                    >
                                        {this.audioSpeedSelect && this.audioSpeedSelect.map((row, idx) => (
                                            <option key={idx} value={row.value}>{row.label}</option>
                                        ))}
                                    </FormControl>
                                </div>
                            </div>
                            {/* 自動スクロール（1行、ラジオ） */}
                            <div className="setting-row">
                                <div className="setting-label">{this.props.childProps.langText.Body.AutoScroll}</div>
                                <div className="setting-control setting-radio-padding-left" key={this.state.pref_auto_scroll}>
                                    <Radio
                                        name="header_pref_auto_scroll"
                                        inline
                                        checked={!!this.state.pref_auto_scroll}
                                        onChange={() => this.onChangeAutoScroll(true)}
                                    >
                                        {this.props.childProps.langText.Body.On}
                                    </Radio>
                                    <Radio
                                        name="header_pref_auto_scroll"
                                        inline
                                        checked={!this.state.pref_auto_scroll}
                                        onChange={() => this.onChangeAutoScroll(false)}
                                    >
                                        {this.props.childProps.langText.Body.Off}
                                    </Radio>
                                </div>
                            </div>
                            {/* 通話録音音声DL（ID付与設定）：通話履歴の出力権限がある場合のみ表示 */}
                            {(() => {
                                const callHistoryPermission = this.props.childProps.userInfo.permission_json_data.find(
                                    permission => permission.controller_id === "CallHistory"
                                );
                                return callHistoryPermission && callHistoryPermission.export ? (
                                    <div className="setting-row">
                                        <div className="setting-label">{this.props.childProps.langText.Body.AddCallHistoryIdToDownload}</div>
                                        <div className="setting-control setting-select-padding-left">
                                            <FormControl
                                                componentClass="select"
                                                className="width-auto display-inline-block"
                                                value={String(this.state.pref_add_call_history_id)}
                                                onChange={e => this.onChangeAddCallHistoryId(e.target.value === 'true')}
                                            >
                                                <option value="false">{this.props.childProps.langText.Body.AddCallHistoryIdNone}</option>
                                                <option value="true">{this.props.childProps.langText.Body.AddCallHistoryIdAdd}</option>
                                            </FormControl>
                                        </div>
                                    </div>
                                ) : null;
                            })()}
                            {/* 保存ボタン（右下） */}
                            <div className="setting-actions margin-bottom-10">
                                <Button bsStyle="primary" onClick={this.handleSavePersonalSettings} disabled={this.state.saving_personal_settings || !this.state.personal_dirty}>
                                    {this.props.childProps.langText.Body.Save}
                                </Button>
                            </div>
                        </div>
                    </>
                }
                <hr/>
                <div class="user-info-footer">
                    <span className="change-password-button"><Button onClick={() => this.handleChangePassword()}>{this.props.childProps.langText.Body.ChangePassword}</Button></span>
                    <span className="logout-button"><Button onClick={this.handleLogout}>{this.props.childProps.langText.Body.LogOut}</Button></span>
                </div>
            </Popover>
        );

        // 通知表示
        let notification_flag = this.props.childProps.notification_flag;
        let notifications = this.props.childProps.notifications;
        let notification_title = (
            <div className="popover-notification-title">
                <span className="left padding-top-08">{this.props.childProps.langText.Body.NotificationTitle}</span>
                <span className="right">
                    <Button 
                        onClick={() => { 
                            this.props.childProps.getNotifications();
                        }}
                    >
                        <Glyphicon glyph="refresh"></Glyphicon>
                    </Button>
                </span>
            </div>
        );
        let notification_info = (
            <Popover id="popover-notification-info" title={notification_title} className="notification-overlay">
                {
                    notification_flag ? 
                    notifications.map(row => {
                        return (
                            <div>
                                <Button
                                    bsStyle="link"
                                    onClick={() => this.downloadHistory("/DownloadHistory", row.id)}
                                >
                                    {`${moment(row.notification_datetime).format("YYYY/MM/DD HH:mm:ss")} ${row.message}`}
                                </Button>
                            </div>  
                        );
                    }) :
                    <div>
                        {this.props.childProps.langText.Message.NotNotificationMessage}
                    </div>
                }
            </Popover>
        );
        let notification_icon = notification_flag ? solidfaIcon.faBell : regularfaIcon.faBell;
        let notification_icon_style = notification_flag ? {color: "rgb(233, 182, 0)"} : {}

        if (this.props.childProps.isAuthenticated) {
            navbarCollapseElem = <Navbar.Collapse>
                <Nav pullRight={true} className="header-nav">
                    {
                        this.state.bookmark_flag && 
                        <NavItem className="Header-Bookmark-Icon">
                            <Button
                                onClick={() => {
                                    const bookmarkPermission = this.props.childProps.userInfo.permission_json_data.find(
                                        permission => permission.controller_id === "Bookmark"
                                    );
                                    if (bookmarkPermission && bookmarkPermission.read) {
                                        this.props.childProps.historyPush("/Bookmark");
                                    } else {
                                        alert(this.props.childProps.langText.Message.PathAuthCheckError);
                                    }
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={solidfaIcon.faBookmark}
                                    size="lg"
                                />
                            </Button>
                        </NavItem>
                    }
                    <NavItem className="Header-notification-icon">
                        <ButtonToolbar>
                            <Button ref={this.notification_button} onClick={() => {this.setShowOverlay()}}>
                                <FontAwesomeIcon
                                    icon={notification_icon}
                                    size="lg"
                                    style={notification_icon_style}
                                />    
                            </Button>
                            <Overlay
                                target={this.notification_button.current}
                                placement="left"
                                show={this.state.overlay_show}
                            >
                                {notification_info}
                            </Overlay>
                        </ButtonToolbar>
                    </NavItem>
                    <NavItem className="Header-User-Icon">
                        <ButtonToolbar>
                            <Button ref={this.user_button} onClick={() => { this.toggleUserMenu(); }}><Glyphicon glyph="user"></Glyphicon></Button>
                            <Overlay
                                target={this.user_button.current}
                                placement="left"
                                show={this.state.user_menu_show}
                                rootClose
                                onHide={this.hideUserMenu}
                            >
                                {user_info}
                            </Overlay>
                        </ButtonToolbar>
                    </NavItem>
                    {this.props.children || null}
                </Nav>
            </Navbar.Collapse>
        }

        return (
            <>
                <Navbar fluid={true} collapseOnSelect={true} className="Header">
                    {navbarHeaderElem}
                    {navbarCollapseElem}
                </Navbar>

                <UserChangeSelfPasswordModal
                    state = {this.state}
                    propSetState = {this.propSetState}
                    userId = {this.props.childProps.userInfo.cm15_id}
                    mailAddress = {this.props.childProps.userInfo.user_id}
                    firstName = {this.props.childProps.userInfo.user_name_sei}
                    lastName = {this.props.childProps.userInfo.user_name_mei}
                    langText = {this.props.childProps.langText}
                    charaLimit = {this.props.childProps.charaLimit}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    passwordValidationHandle = {this.passwordValidationHandle}
                />
            </>
        );
    }
}
